import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import ApiClient from '../../../service/apiClient';
import {sortBy} from '../../../service/util';

interface SliceType {
    loading: boolean;
    from: string,
    to: string,
    drugs: WidgetDrugsData[],
}

const initialState: SliceType = {
    loading: false,
    from: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD'),
    drugs: [],
};

const slice = createSlice({
    name: 'drugsWidget',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setDates: (state, action: PayloadAction<{from: string, to: string}>) => {
            state.from = action.payload.from;
            state.to = action.payload.to;
        },
        setDrugs: (state, action: PayloadAction<WidgetDrugsData[]>) => {
            state.drugs = sortBy(action.payload, 'date');
        },
    },
});

export const actions = slice.actions;

export const init = (from: string, to: string) => (dispatch: FixType) => {
    dispatch(actions.setLoading(true));

    const data = ApiClient.getDrugsWidgetData(from, to)
        .then((response) => dispatch(actions.setDrugs(response)))
        .catch(() => dispatch(actions.setDrugs([])));

    Promise.all([data]).then(() => dispatch(actions.setLoading(false)));
};

export default slice.reducer;